import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Slot} from "../../data/Slot";
import SlotCreation from "./SlotCreation";
import {TabPanel, TabView} from "primereact/tabview";
import {Button} from "primereact/button";
import ExportPanel from "./ExportPanel";
import SlotListCompontent from "./SlotListComponent";

function AdminInternalPanel({
                                isLoggedIn,
                                onLogout,
                            }: {
    isLoggedIn: boolean;
    onLogout(): void;
}) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [slots, setSlots] = useState<Slot[] | null>(null);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        async function fetchSlots() {
            setIsLoading(true);

            const response = await fetch(
                `/api/slot/entries`,
                {
                    credentials: "include",
                },
            );
            const resData = await response.json();
            const slots = resData.map((element: any) => {
                const slot = Object.assign(new Slot(), element);
                slot.startDateTime = new Date(element.startDateTime);
                slot.endDateTime = new Date(element.endDateTime);
                return slot;
            });

            setIsLoading(false);
            slots.sort((s1: Slot, s2: Slot) => {
                return s1.startDateTime.getTime() - s2.startDateTime.getTime();
            });
            setSlots(slots);
        }

        fetchSlots();
    }, [isLoggedIn]);

    function onSlotCreated(slot: Slot) {
        const newSlots = [...slots!, slot];
        newSlots.sort((s1, s2) => {
            return s1.startDateTime.getTime() - s2.startDateTime.getTime();
        });

        setSlots(newSlots);
    }

    function onSlotChanged(updatedSlot: Slot) {
        if (slots === null) return;

        const updatedSlots = slots.map((slot) =>
            slot.id === updatedSlot.id ? updatedSlot : slot,
        );
        updatedSlots.sort((s1, s2) => {
            return s1.startDateTime.getTime() - s2.startDateTime.getTime();
        });

        setSlots(updatedSlots);
    }

    function onSlotDeleted(slot: Slot) {
        if (slots === null) return;

        const updatedSlots = slots.filter((s) => s.id !== slot.id);

        setSlots(updatedSlots);
    }

    return (
        <div>
            <div className="flex justify-content-between">
                <Button
                    label="Zurück"
                    onClick={() => navigate("/")}
                    severity="secondary"
                    className="w-5 sm:w-3"
                    icon="pi pi-arrow-left"
                ></Button>
                <Button
                    label="Ausloggen"
                    onClick={onLogout}
                    className="w-5 sm:w-3"
                    icon="pi pi-sign-out"
                ></Button>
            </div>
            {!isLoading && (
                <TabView>
                    <TabPanel header="Termine">
                        {slots !== null && (
                            <SlotListCompontent
                                slots={slots}
                                onSlotChanged={onSlotChanged}
                                onSlotDeleted={onSlotDeleted}
                            />
                        )}
                    </TabPanel>
                    <TabPanel header="Termin erstellen">
                        <SlotCreation onSlotCreated={onSlotCreated}/>
                    </TabPanel>

                    <TabPanel header="Exporter">
                        <ExportPanel slots={slots}/>
                    </TabPanel>
                </TabView>
            )}
        </div>
    );
}

export default AdminInternalPanel;
